var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcGold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F8B24F",
  d: "M5.621 6.765a2 2 0 0 1 1.94-1.515h8.877a2 2 0 0 1 1.94 1.515l.5 2a2 2 0 0 1-1.94 2.485H7.062a2 2 0 0 1-1.94-2.485l.5-2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FEF0DC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.125 9.75h3.75M12.75 9.75h.75"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8B24F",
  d: "M2.202 14.43a2 2 0 0 1 1.974-1.68h4.398a2 2 0 0 1 1.974 1.68l.325 2a2 2 0 0 1-1.974 2.32H3.85a2 2 0 0 1-1.974-2.32l.325-2ZM13.452 14.43a2 2 0 0 1 1.974-1.68h4.398a2 2 0 0 1 1.974 1.68l.325 2a2 2 0 0 1-1.974 2.32H15.1a2 2 0 0 1-1.974-2.32l.325-2Z"
})));
export default SvgIcGold;